dtp_defaults = {
  format: 'YYYY-MM-DD'
  icons: {
    time: "fa fa-clock-o"
    date: "fa fa-calendar"
    up: "fa fa-arrow-up"
    down: "fa fa-arrow-down"
    previous: 'fa fa-chevron-left'
    next: 'fa fa-chevron-right'
    today: 'fa fa-desktop'
    clear: 'fa fa-trash',
    close: 'fa fa-times'
  }
}

ttp_defaults = $.extend(true, {}, dtp_defaults)
ttp_defaults.format = 'hh:mm A'
ttp_defaults.stepping = 15
ttp_defaults.useCurrent = false

launch_picker = (defaults, el)->
  if el.is('input')
    options = el.data('options')
  else
    options = el.find('input').data('options')
  el.datetimepicker($.extend({}, defaults, options))

launch_datepicker = ->
  launch_picker(dtp_defaults, $(this))

launch_timepicker = ->
  launch_picker(ttp_defaults, $(this))

launch_datepicker_with_options = (el, custom_defaults = {}) ->
  defaults = $.extend(true, custom_defaults, dtp_defaults)
  launch_picker(defaults, el)

launch_timepicker_with_options = (el, custom_defaults = {}) ->
  defaults = $.extend(true, custom_defaults, ttp_defaults)
  launch_picker(defaults, $(el))

$(->
  $('input.date').each launch_datepicker
  $('.input-group.date').each launch_datepicker

  $(document).on 'show.bs.modal', '.modal', ->
    $(this).find('input.date, .input-group.date').each launch_datepicker

  $('.input-group.time').each launch_timepicker

  $(document).on 'show.bs.modal', '.modal', ->
    $(this).find('.input-group.time').each launch_timepicker
)

module.exports =
  launch_datepicker: launch_datepicker
  launch_timepicker: launch_timepicker
  launch_datepicker_with_options: launch_datepicker_with_options
  launch_timepicker_with_options: launch_timepicker_with_options
